import { app } from '../actions/actionTypes';
export const appInitialState = {
    phone: '',
    email: '',
    imagesUrls: {},
    shouldReqContactsPermission: true,
    initialized: false,
    preferences: { folderIcon: 'blue' },
    currentDeviceId: null,
    subscription: {
        platform: 'ios',
        expires: null,
    },
    currentTarget: null,
    profilePictureUri: null,
};
export default function (state = appInitialState, action) {
    switch (action.type) {
        case app.CONFIRM_NUMBER_RESPONSE:
            const confirmNumberResponsePayload = action.payload;
            return { ...state, phone: confirmNumberResponsePayload.phone };
        case app.INITIALIZED:
            return { ...state, initialized: true };
        case app.CURRENT_DEVICE_ID:
            const currentDeviceIdPayload = action.payload;
            return { ...state, currentDeviceId: currentDeviceIdPayload };
        case app.USER_PREFERENCES:
            const userPreferencesPayload = action.payload;
            return { ...state, preferences: { ...state.preferences, ...userPreferencesPayload } };
        case app.DISPATCH_EMAIL:
            const dispatchEmailPayload = action.payload;
            return { ...state, email: dispatchEmailPayload.email };
        case app.DISPATCH_SUBSCRIPTION_DETAILS:
            const dispatchSubscriptionDetailsPayload = action.payload;
            return { ...state, subscription: dispatchSubscriptionDetailsPayload };
        case app.PROFILE_PICTURE:
            const profilePicturePayload = action.payload;
            return { ...state, profilePictureUri: profilePicturePayload };
        case app.RESET_APP_STATE:
            return appInitialState;
        default:
            return state;
    }
}
